// Экспериментальный стимулятор (deus_eksperimentalnyy_stimulyator, cost 4) — oneshot.
// Обнуляет кулдаун active Героя (флаг heroActiveUsed -> false).
// Если active не использовалось — эффект всё равно «срабатывает» (Игрок зря потратил очки).

import { chargeInfluence } from './influence.js';

export const CARD_ID = 'deus_eksperimentalnyy_stimulyator';
export const COST = 4;

export function canPlayStimulator(state, playerIdx) {
  const p = state.players[playerIdx];
  if (p.influence < COST) return { ok: false, reason: 'not_enough_influence' };
  return { ok: true };
}

export function playStimulator(state, playerIdx) {
  const can = canPlayStimulator(state, playerIdx);
  if (!can.ok) return can;
  const p = state.players[playerIdx];
  if (!chargeInfluence(state, playerIdx, COST)) return { ok: false, reason: 'not_enough_influence' };
  if (p.heroActiveUsed) {
    p.heroActiveUsed = false;
    state.log.add(`💉 ${p.name}: Стимулятор — кулдаун active Героя сброшен`);
  } else {
    state.log.add(`💉 ${p.name}: Стимулятор — active Героя ещё не использовался, очки потрачены впустую`);
  }
  return { ok: true };
}
